import React from 'react'

const DocumentIcon = ({color = '#808F94', ...props}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.332 24.6" width={20.332} height={25} {...props}>
      <g fill={color}>
        <path d="m14.063.977 4.931 5.01c.733.751.977 1.513.977 2.714v7.93c0 2.031-1.016 3.066-3.028 3.066h-1.709v-1.572h1.621c1.016 0 1.543-.547 1.543-1.523v-8.35h-4.57c-1.123 0-1.67-.537-1.67-1.67v-5.01H7.842c-1.016 0-1.533.557-1.533 1.524v1.777H4.736V3.066C4.736 1.036 5.752 0 7.764 0h3.74c1.045 0 1.865.264 2.559.977Zm-.489 5.37c0 .342.137.489.479.489h3.935l-4.414-4.492Z" />
        <path d="M0 21.504c0 2.04 1.006 3.066 3.027 3.066h9.18c2.021 0 3.027-1.035 3.027-3.066v-7.627c0-1.25-.146-1.797-.927-2.598L8.926 5.801c-.742-.762-1.358-.928-2.451-.928H3.027C1.016 4.873 0 5.898 0 7.939Zm1.572-.03V7.96c0-.957.518-1.514 1.533-1.514H6.31v5.664c0 1.23.625 1.846 1.836 1.846h5.517v7.52c0 .976-.527 1.523-1.533 1.523H3.096c-1.006 0-1.524-.547-1.524-1.523ZM8.33 12.48c-.39 0-.547-.156-.547-.546V6.807l5.576 5.673Z" />
      </g>
    </svg>
  )
}

export default DocumentIcon
